const achievements = [
  // 🔹 AI & Generative AI
  {
    title: "Anthropic Claude Architect Foundation",
    org: "Anthropic",
    year: "Apr 2026",
    description: "Certified expertise in designing and architecting solutions using Anthropic's Claude AI models.",
    badges: ["AI", "GenAI", "Claude"],
    stars: 5,
    expiry: "Oct 2026",
    renewed: "--"
  },
  {
    title: "Databricks Generative AI Fundamentals",
    org: "Databricks",
    year: "2026",
    description: "Proficiency in building and deploying Generative AI solutions on the Databricks Lakehouse platform.",
    badges: ["Databricks", "GenAI", "AI"],
    stars: 5,
    expiry: "--",
    renewed: "--"
  },

  // 🔹 Microsoft Azure
  {
    title: "AZ-900: Microsoft Azure Fundamentals",
    org: "Microsoft",
    year: "2023",
    description: "Fundamental cloud concepts and Azure services.",
    badges: ["Azure", "Cloud"],
    stars: 4,
    expiry: "--",
    renewed: "--"
  },
  {
    title: "AZ-104: Microsoft Azure Administrator",
    org: "Microsoft",
    year: "2025",
    description: "Certified skills in managing Azure subscriptions, identities, infrastructure, and cloud resources.",
    badges: ["Azure", "Administrator"],
    stars: 4,
    expiry: "2027",
    renewed: "--"
  },
  {
    title: "AZ-204: Developing Solutions for Microsoft Azure",
    org: "Microsoft",
    year: "2024",
    description: "Hands-on expertise in building, deploying, and maintaining cloud apps.",
    badges: ["Azure", "Developer"],
    stars: 4,
    expiry: "2026",
    renewed: "2025"
  },
  {
    title: "AZ-400: Microsoft Certified: DevOps Engineer Expert",
    org: "Microsoft",
    year: "2024",
    description: "Expert-level skills in DevOps, CI/CD pipelines, and automation.",
    badges: ["Azure", "DevOps", "Expert"],
    stars: 5,
    expiry: "2026",
    renewed: "2025"
  },
  {
    title: "DP-203: Data Engineering on Microsoft Azure",
    org: "Microsoft",
    year: "2024",
    description: "Designing and implementing data solutions on Azure.",
    badges: ["Azure", "Data Engineering"],
    stars: 4,
    expiry: "2026",
    renewed: "2025"
  },
  {
    title: "DP-300: Administering Relational Databases on Microsoft Azure",
    org: "Microsoft",
    year: "2024",
    description: "Managing and securing Azure SQL databases.",
    badges: ["Azure", "Database"],
    stars: 4,
    expiry: "2026",
    renewed: "2025"
  },

  // 🔹 Oracle Cloud
  {
    title: "1Z0-1085-23: Oracle Cloud Infrastructure 2023 Foundations Associate",
    org: "Oracle",
    year: "2023",
    description: "Validated foundational knowledge of OCI services.",
    badges: ["Oracle", "Cloud"],
    stars: 3,
    expiry: "2025",
    renewed: "2024"
  },
  {
    title: "1Z0-1085-24: Oracle Cloud Infrastructure 2024 Foundations Associate",
    org: "Oracle",
    year: "2024",
    description: "Validated foundational knowledge of OCI services.",
    badges: ["Oracle", "Cloud"],
    stars: 3,
    expiry: "2026",
    renewed: "2025"
  },
  {
    title: "1Z0-1085-25: Oracle Cloud Infrastructure 2025 Foundations Associate",
    org: "Oracle",
    year: "2025",
    description: "Validated foundational knowledge of OCI services.",
    badges: ["Oracle", "Cloud"],
    stars: 3,
    expiry: "2027",
    renewed: "--"
  },
  {
    title: "1Z0-1072-23: Oracle Cloud Infrastructure 2023 Architect Associate",
    org: "Oracle",
    year: "2023",
    description: "Certified expertise in OCI solution architecture.",
    badges: ["Oracle", "Architecture"],
    stars: 4,
    expiry: "--",
    renewed: "--"
  },
  {
    title: "1Z0-1105-23: Oracle Cloud Data Management 2023 Foundations Associate",
    org: "Oracle",
    year: "2023",
    description: "Strong foundation in Oracle Cloud data management.",
    badges: ["Oracle", "Data"],
    stars: 3,
    expiry: "2025",
    renewed: "2024"
  },
  {
    title: "1Z0-1105-24: Oracle Cloud Data Management 2024 Foundations Associate",
    org: "Oracle",
    year: "2024",
    description: "Strong foundation in Oracle Cloud data management.",
    badges: ["Oracle", "Data"],
    stars: 3,
    expiry: "2026",
    renewed: "2025"
  },
  {
    title: "1Z0-1105-25: Oracle Cloud Data Management 2025 Foundations Associate",
    org: "Oracle",
    year: "2025",
    description: "Strong foundation in Oracle Cloud data management.",
    badges: ["Oracle", "Data"],
    stars: 3,
    expiry: "2027",
    renewed: "--"
  },
  {
    title: "1Z0-1122-24: Oracle Cloud Infrastructure 2024 AI Foundations Associate",
    org: "Oracle",
    year: "2024",
    description: "Certified expertise in AI & ML workloads on OCI.",
    badges: ["Oracle", "AI", "Cloud"],
    stars: 4,
    expiry: "2026",
    renewed: "2025"
  },
  {
    title: "1Z0-1122-25: Oracle Cloud Infrastructure 2025 AI Foundations Associate",
    org: "Oracle",
    year: "2025",
    description: "Certified expertise in AI & ML workloads on OCI.",
    badges: ["Oracle", "AI", "Cloud"],
    stars: 4,
    expiry: "2027",
    renewed: "--"
  },

  // 🔹 Java
  {
    title: "Oracle Java SE 8 Programmer I & II",
    org: "Oracle",
    year: "2024-2025",
    description: "Advanced knowledge in Java SE 8 programming.",
    badges: ["Java", "Programming"],
    stars: 4,
    expiry: "--",
    renewed: "--"
  },
  {
    title: "Oracle Java SE 17 Programmer",
    org: "Oracle",
    year: "2025",
    description: "Certified in Java SE 17 programming features.",
    badges: ["Java", "Programming"],
    stars: 5, 
    expiry: "--",
    renewed: "--"
  },

  // 🔹 MongoDB
  {
    title: "MongoDB SI Associate Certified",
    org: "MongoDB",
    year: "2024",
    description: "Certified MongoDB Associate Developer.",
    badges: ["MongoDB", "Database"],
    stars: 4,
    expiry: "--",
    renewed: "--"
  },
  {
    title: "MongoDB SI Architect Certified",
    org: "MongoDB",
    year: "2024",
    description: "Certified MongoDB Solution Architect.",
    badges: ["MongoDB", "Architecture"],
    stars: 5, 
    expiry: "--",
    renewed: "--"
  },

  // 🔹 Neo4J
  {
    title: "Neo4J Professional Certified",
    org: "Neo4J",
    year: "2024",
    description: "Proficiency in Neo4J Graph Database.",
    badges: ["Neo4J", "Graph DB"],
    stars: 3,
    expiry: "--",
    renewed: "--"
  },
];

export { achievements };